'use strict';

export default {
  1: {
    name: `Patient`,
    defaultRoute: `dashboard-requests`,
  },
  2: {
    name: `Doctor`,
    defaultRoute: `dashboard-requests`,
  },
  3: {
    name: `Reviewer`,
    defaultRoute: `dashboard-reviews`,
  },
  42: {
    name: `Admin`,
    defaultRoute: `admin-reviewer-requests`,
  },
};



// WEBPACK FOOTER //
// ./client/models/global/roles.js